import { render, staticRenderFns } from "./TermsDetailForm.vue?vue&type=template&id=792f5f23&scoped=true&"
import script from "./TermsDetailForm.vue?vue&type=script&lang=js&"
export * from "./TermsDetailForm.vue?vue&type=script&lang=js&"
import style0 from "./TermsDetailForm.vue?vue&type=style&index=0&id=792f5f23&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792f5f23",
  null
  
)

export default component.exports